import { EcardSendFormData } from '@dotcom/crown-ui';
import { RegisterOptions } from 'react-hook-form';
import { validateEmail, validateNames } from '../../../components/address-form/address-utils';

type Translate = (key: string, options?: Record<string, string | number>) => string;
type EcardFieldChange = (field: keyof EcardSendFormData, value: string) => void;

export const getEcardValidationRules = (
  t: Translate,
  onFieldChange: EcardFieldChange,
): Record<keyof EcardSendFormData, RegisterOptions<EcardSendFormData>> => {
  const shortFieldError = (min: number, max: number) => t('addressUtil.shortFieldError', { min, max });
  const required = (field: string) => t('emailAddressForm.isRequired', { requirement: t(`emailAddressForm.${field}`) });
  const nameRules = (
    field: keyof EcardSendFormData,
    label: string,
    maxLength: number,
  ): RegisterOptions<EcardSendFormData> => ({
    required: required(label),
    minLength: { value: 2, message: shortFieldError(2, maxLength) },
    maxLength: { value: maxLength, message: shortFieldError(2, maxLength) },
    validate: (value) => validateNames(value, (key) => t(key)),
    onChange: async (event) => onFieldChange(field, event.target.value),
  });

  return {
    recipientFirstName: nameRules('recipientFirstName', 'recipientFirstName', 15),
    recipientLastName: nameRules('recipientLastName', 'recipientLastName', 20),
    recipientEmail: {
      required: required('contactInfo'),
      minLength: { value: 1, message: shortFieldError(1, 55) },
      maxLength: { value: 55, message: shortFieldError(1, 55) },
      validate: (value) => validateEmail(value, t('addressUtil.validEmailError')),
      onChange: async (event) => onFieldChange('recipientEmail', event.target.value),
    },
    senderFirstName: nameRules('senderFirstName', 'senderFirstName', 15),
    senderLastName: nameRules('senderLastName', 'senderLastName', 20),
  };
};
